import PropTypes from "prop-types";
import { Heading } from "evergreen-ui";
import { Text, Tooltip } from "components/materials";
import { Position } from "helpers/utilities";

function getDynamicFontSize(
  defaultFontSize,
  limit,
  textLength,
  minimumFontSize
) {
  const dynamicFontSize =
    textLength > limit
      ? defaultFontSize * (limit / textLength)
      : defaultFontSize;

  return dynamicFontSize >= minimumFontSize ? dynamicFontSize : minimumFontSize;
}

function Shortener({
  fontSize: defaultFontSize,
  text,
  limit,
  isLink,
  minimumFontSize,
  tooltip,
  tooltipPosition,
  useDynamicFontSize,
  ...props
}) {
  if (!text) return "";
  const fontSize = useDynamicFontSize
    ? getDynamicFontSize(defaultFontSize, limit, text.length, minimumFontSize)
    : defaultFontSize;
  const colorProp = isLink ? { color: "selected" } : {};
  const TextComponent = props.size > 500 ? Heading : Text;
  const styleProps = props ? { ...props, fontSize } : { fontSize };

  if (text.length <= limit) {
    return (
      <TextComponent {...colorProp} {...styleProps}>
        {text}
      </TextComponent>
    );
  }

  const short = text.substring(0, limit).concat("...");

  return tooltip ? (
    <Tooltip position={tooltipPosition} content={text}>
      <TextComponent {...colorProp} {...styleProps}>
        {short}
      </TextComponent>
    </Tooltip>
  ) : (
    <TextComponent {...colorProp} {...styleProps}>
      {short}
    </TextComponent>
  );
}

export default Shortener;

Shortener.propTypes = {
  text: PropTypes.string,
  limit: PropTypes.number.isRequired,
  isLink: PropTypes.bool,
  minimumFontSize: PropTypes.number,
  tooltip: PropTypes.bool,
  tooltipPosition: PropTypes.string,
};

Shortener.defaultProps = {
  minimumFontSize: 12,
  tooltip: true,
  tooltipPosition: Position.TOP,
};
